import React from 'react'
import PeriodSelect from '../PeriodSelect/PeriodSelect'
import { ReportIcon } from '../ReportIcon/ReportIcon'
import s from './Toolbar.module.scss'

/**
 * Report page toolbar with period filter, export button, and optional extra filters.
 * Previously called ReportToolbar.
 */
export const Toolbar = ({
	variant = 'default',
	period,
	periods,
	onPeriodChange,
	customFrom = '',
	customTo = '',
	onCustomFromChange,
	onCustomToChange,
	onApplyCustom,
	canApplyCustom = false,
	customRangeInvalid = false,
	triggerLabel,
	onExport,
	exportLabel = 'Export CSV',
	contextLabel = 'Academic year 2026-27',
	children,
}) => (
	<div className={`${s.toolbar} ${s[`toolbar--${variant}`] || ''}`.trim()}>
		<div className={s['toolbar__context']}>
			<div>
				<span className={s['toolbar__context-label']}>Report context</span>
				<strong className={s['toolbar__context-value']}>{contextLabel}</strong>
			</div>
		</div>
		<div className={s['toolbar__actions']}>
			<div className={s['toolbar__filters']}>
				<div className={s['field-label']}>
					<span className={s['field-label__text']}>Reporting period</span>
					<PeriodSelect
						value={period}
						onChange={onPeriodChange}
						options={periods}
						customFrom={customFrom}
						customTo={customTo}
						onCustomFromChange={onCustomFromChange}
						onCustomToChange={onCustomToChange}
						onApplyCustom={onApplyCustom}
						canApplyCustom={canApplyCustom}
						customRangeInvalid={customRangeInvalid}
						triggerLabel={triggerLabel}
						placeholder="Select period"
						minMenuWidth={240}
						menuZIndex={3000}
					/>
				</div>
				{children}
			</div>
			<button type="button" className={`${s.btn} ${s['btn--primary']}`} onClick={onExport}>
				<ReportIcon name="download" className={s['btn__icon']} />
				<span className={s['btn__label']}>{exportLabel}</span>
			</button>
		</div>
	</div>
)

/** Standalone field label wrapper for extra toolbar filters. */
export const FieldLabel = ({ label, children }) => (
	<div className={s['field-label']}>
		<span className={s['field-label__text']}>{label}</span>
		{children}
	</div>
)

export default Toolbar
